import { useEffect, useState } from 'react'
import moment from 'moment/moment'
import useLocalStorage from './useLocalStorage'
import { useNeedsUserSurveyUpdateQuery } from '../Generated/graphql-types'

export const useSnoozeCheckInSurvey = () => {
  const SNOOZE_CHECK_IN_SURVEY_KEY = 'ignore-check-in-survey-timestamp'
  const MAX_SNOOZE_DAYS = 7
  const [isTimeToPromptUser, setIsTimeToPromptUser] = useState(false)
  const [lastSnoozeTimeStamp, setLastSnoozeTimestamp] = useLocalStorage(
    SNOOZE_CHECK_IN_SURVEY_KEY
  )

  const { data: checkEligibilityData, loading: checkInEligibilityLoading } =
    useNeedsUserSurveyUpdateQuery()

  // Reset local storage if the user needs to be nudged to take survey again
  useEffect(() => {
    if (checkInEligibilityLoading) return

    if (!moment.utc(lastSnoozeTimeStamp, moment.ISO_8601).isValid())
      // User has never snoozed the survey
      setIsTimeToPromptUser(true)
    else {
      const lastTimeSurveyWasSkipped = moment.utc(lastSnoozeTimeStamp)
      const now = moment.utc()
      const daysSinceLastSkip = now.diff(lastTimeSurveyWasSkipped, 'days')
      if (daysSinceLastSkip > MAX_SNOOZE_DAYS) setIsTimeToPromptUser(true)
    }
  }, [checkInEligibilityLoading, lastSnoozeTimeStamp, setLastSnoozeTimestamp])

  const isTimeForCheckInSurvey =
    checkEligibilityData?.needsUserSurveyUpdate && isTimeToPromptUser

  const snoozeSurvey = () => {
    setLastSnoozeTimestamp(moment.utc().toISOString())
    setIsTimeToPromptUser(false)
  }

  return {
    loading: checkInEligibilityLoading,
    isEligibleForSurvey: checkEligibilityData?.needsUserSurveyUpdate,
    isTimeForCheckInSurvey,
    snoozeSurvey,
  }
}
